(function() {
  define('bazemont/gallery/pictures',['angular'], function() {
    'use strict';
    return angular.module('bazemontGalleryPictures', []).component('bazemontGalleryPictures', {
      templateUrl: '/assets/javascripts/bazemont/gallery/pictures.html',
      bindings: {
        pictures: '=',
        max: '@',
        maxWidth: '@',
        nbColumns: '@',
        hasPreview: '<'
      },
      controller: [
        '$q', 'TlhNotificationService', 'TlhArrayService', 'TlhImageService', 'TlhPictureService', 'TlhPositionService', 'TlhConfirmModalService', function($q, TlhNotificationService, TlhArrayService, TlhImageService, TlhPictureService, TlhPositionService, TlhConfirmModalService) {
          var getImageFilesFromInput, getNextPosition, input, vm;
          vm = this;
          if (vm.pictures == null) {
            vm.pictures = [];
          }
          if (vm.maxWidth == null) {
            vm.maxWidth = 1000;
          }
          vm.isImporting = false;
          vm.hasActivePictures = function() {
            return TlhArrayService.hasActiveElements(vm.pictures);
          };
          vm.getNbActivePictures = function() {
            return TlhArrayService.getNbActiveElements(vm.pictures);
          };
          vm.addNewPictures = function() {
            return input.click();
          };
          vm.setPreviewPicture = function(selectedPicture) {
            var picture, _i, _len, _ref, _results;
            if (selectedPicture == null) {
              selectedPicture = TlhArrayService.getFirstActiveElement(vm.pictures);
            }
            _ref = vm.pictures;
            _results = [];
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              picture = _ref[_i];
              _results.push(picture.isPreviewPicture = picture === selectedPicture);
            }
            return _results;
          };
          vm.movePictureUp = function(picture) {
            return TlhPositionService.moveElementUp(picture, vm.pictures);
          };
          vm.movePictureDown = function(picture) {
            return TlhPositionService.moveElementDown(picture, vm.pictures);
          };
          vm.trashAllPictures = function() {
            var message;
            message = '<p class="text-center">Êtes-vous sûr(e) de vouloir supprimer toutes les photos ?</p>';
            return TlhConfirmModalService.open(message).result.then(function(result) {
              var picture, _i, _len, _ref, _results;
              if (result.confirm) {
                _ref = vm.pictures;
                _results = [];
                for (_i = 0, _len = _ref.length; _i < _len; _i++) {
                  picture = _ref[_i];
                  _results.push(picture.isActive = false);
                }
                return _results;
              }
            });
          };
          input = document.createElement('input');
          input.type = 'file';
          input.accept = 'image/*';
          input.multiple = true;
          input.onchange = function() {
            var chain, imageFiles;
            input = this;
            if (input && input.files) {
              imageFiles = getImageFilesFromInput(input.files);
              if (imageFiles && imageFiles.length > 0) {
                vm.isImporting = true;
                TlhNotificationService.info({
                  message: 'Importation en cours...',
                  delay: false
                });
                chain = imageFiles.reduce(function(sourcesPromise, file) {
                  return sourcesPromise.then(function() {
                    return TlhImageService.resizeImageFile(file, vm.maxWidth).then(function(resizedImage) {
                      var picture, position;
                      file = {
                        url: resizedImage.dataUrl,
                        filename: resizedImage.filename,
                        mimeType: resizedImage.mimeType
                      };
                      position = getNextPosition();
                      picture = {
                        isActive: true,
                        position: position,
                        file: file
                      };
                      return vm.pictures.push(picture);
                    });
                  });
                }, $q.when());
                return chain.then(function() {
                  if (vm.hasPreview && !TlhPictureService.hasPreviewPicture(vm.pictures)) {
                    vm.setPreviewPicture();
                  }
                  TlhNotificationService.success({
                    message: 'Importation terminée',
                    replaceMessage: true
                  });
                  return vm.isImporting = false;
                });
              } else {
                return TlhNotificationService.warning({
                  message: 'Votre sélection ne contient pas d\'image.'
                });
              }
            }
          };
          getImageFilesFromInput = function(files) {
            var file, images, _i, _len;
            images = [];
            if (files && files.length > 0) {
              for (_i = 0, _len = files.length; _i < _len; _i++) {
                file = files[_i];
                if (TlhImageService.isImageFile(file)) {
                  if (vm.max && vm.getNbActivePictures() + images.length >= vm.max) {
                    TlhNotificationService.warning({
                      message: 'Le nombre maximum de photos est atteint.'
                    });
                    break;
                  } else {
                    images.push(file);
                  }
                } else {
                  TlhNotificationService.warning({
                    message: 'Le fichier ' + file.name + ' n\'est pas une image.'
                  });
                }
              }
            }
            return images;
          };
          getNextPosition = function() {
            var picture, position, _i, _len, _ref;
            if (vm.pictures == null) {
              vm.pictures = [];
            }
            position = 1;
            _ref = vm.pictures;
            for (_i = 0, _len = _ref.length; _i < _len; _i++) {
              picture = _ref[_i];
              position++;
            }
            return position;
          };
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=pictures.js.map
;
